export default "__VITE_ASSET__3cf40cc7__"